export default __webpack_public_path__ + "static/media/criatividade.6bfe524d.png";